<form
  #form
  (ngSubmit)="submit()"
  [appApiAction]="formPromise"
  class="tw-container tw-mx-auto"
  [formGroup]="formGroup"
>
  <div
    class="tw-mt-6 tw-w-full tw-rounded-3xl tw-bg-color-surface-card tw-py-8 tw-px-12 shadow-fade-card sm:tw-px-8 sm:tw-mt-0"
  >
    <ng-container>
      <div class="tw-mb-3">
        <p
          class="tw-text-center tw-px-8 tw-font-medium tw-text-[14px] tw-text-color-text-secondary sm:tw-px-1"
        >
          {{ "loginOrCreateNewAccount" | i18n }}
        </p>
        <bit-form-field>
          <bit-label
            class="tw-font-semibold tw-text-[14px] tw-text-color-text-tertiary sm:tw-text-[12px]"
            >{{ "emailAddress" | i18n }}</bit-label
          >
          <div class="tw-relative tw-w-full">
            <div
              class="tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-3 pointer-events-none"
            >
              <icon [name]="'mail'" [size]="5" class="tw-mr-2"></icon>
            </div>
            <input
              id="login_input_email"
              data-testid="login_input_email"
              bitInput
              type="email"
              formControlName="email"
              autocomplete="email"
              appAutofocus
              (keyup.enter)="submit()"
              placeholder="{{ 'emailAddress' | i18n }}"
              class="tw-bg-color-surface-input placeholder:tw-text-color-text-tertiary tw-font-normal tw-text-[12px] tw-pl-10 shadow-fade-input"
            />
          </div>
        </bit-form-field>
      </div>

      <div class="tw-h-24">
        <bit-form-field class="!tw-mb-1" [isCustomisedTitle]="true">
          <bit-label
            class="tw-font-semibold tw-text-[14px] tw-text-color-text-tertiary sm:tw-text-[12px]"
            >{{ "masterPass" | i18n }}</bit-label
          >
          <div class="tw-flex tw-gap-2" customized-title>
            <a
              class="tw-flex tw-items-center tw-font-normal tw-text-[12px] tw-text-color-text-default"
              routerLink="/hint"
              (mousedown)="goToHint()"
              (click)="setFormValues()"
            ></a>
            <icon [name]="'help'" [size]="6" class="tw-text-dt-custom-teal-9"></icon>
          </div>
          <div class="tw-relative tw-w-full">
            <div
              class="tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-items-center tw-pl-3 pointer-events-none"
            >
              <icon [name]="'lock-03'" [size]="5"></icon>
            </div>
            <input
              id="login_input_master-password"
              data-testid="login_input_master-password"
              data-form-type="”password”"
              type="password"
              bitInput
              formControlName="password"
              autocomplete="password"
              appAutofocus
              (keyup.enter)="submit()"
              placeholder="{{ 'enterPassword' | i18n }}"
              class="tw-pr-12 tw-bg-color-surface-input tw-text-color-text-tertiary tw-font-normal tw-text-[12px] tw-pl-10 tw-w-full shadow-fade-input"
            />
          </div>
          <button
            type="button"
            bitSuffix
            bitPasswordInputToggle
            [(toggled)]="showPassword"
            class="tw-h-full tw-bg-transparent tw-flex tw-items-center"
          >
            <svg class="tw-h-6 tw-w-6 tw-opacity-60 tw-text-color-icon-default">
              <use
                [attr.xlink:href]="
                  showPassword ? 'images/sprite.svg#eye' : 'images/sprite.svg#eye-off'
                "
              ></use>
            </svg>
          </button>
        </bit-form-field>
      </div>

      <div [hidden]="!showCaptcha()">
        <iframe id="hcaptcha_iframe" height="80"></iframe>
      </div>

      <div class="tw-mb-6">
        <div
          class="tw-flex tw-flex-col min-sm:tw-flex-row tw-w-full tw-gap-2 min-sm:tw-justify-between min-sm:tw-items-center"
        >
          <div
            class="tw-flex tw-items-center tw-font-normal tw-text-[12px] tw-text-color-text-default tw-self-end min-sm:tw-self-auto tw-order-1 min-sm:tw-order-2"
          >
            {{ "needHelpContactUs" | i18n }}
            <button type="button" (click)="goSupport()">
              <span
                class="tw-text-color-text-action tw-flex tw-items-center tw-underline tw-font-bold sm:tw-font-medium"
              >
                {{ "support" | i18n }}
              </span>
            </button>
          </div>
          <app-checkbox
            id="login_input_remember-email"
            [title]="'rememberEmail' | i18n"
            class="tw-font-medium tw-text-[12px] tw-text-dt-text-headings min-sm:tw-ml-0 tw-order-2 min-sm:tw-order-1"
            [checked]="formGroup.get('rememberEmail').value"
            (onChange)="formGroup.get('rememberEmail').setValue($event)"
          ></app-checkbox>
        </div>
      </div>

      <div class="tw-flex tw-flex-col tw-gap-2">
        <app-gloss-button
          [options]="{
            text: 'login' | i18n,
            type: 'submit',
            fullClass: 'tw-bg-dt-custom-teal-11 tw-h-12 tw-w-full tw-px-6 tw-rounded-full ',
            onClick: submit.bind(this),
            isEnabled: !isLoading,
            testId: 'loginButton',
          }"
          fontClass="!tw-font-bold tw-text-[16px] tw-text-dt-slate-0"
          [isLoading]="isLoading"
        >
        </app-gloss-button>

        <app-gloss-button
          *ngIf="showLoginWithDevice && showPasswordless"
          [options]="{
            text: 'loginWithDevice' | i18n,
            type: 'submit',
            class: 'neutral',
            onClick: startPasswordlessLogin.bind(this),
            isEnabled: !form.loading,
            testId: 'loginButtonPasswordless',
          }"
        >
        </app-gloss-button>
      </div>

      @if (showGoogleSignIn) {
        <div class="tw-flex tw-flex-col tw-gap-2 tw-items-center tw-mt-6">
          <div class="tw-flex tw-items-center tw-w-full">
            <div
              class="tw-flex-1 tw-border tw-border-color-border-subtle tw-shadow-border-bottom"
            ></div>
            <div class="tw-text-color-text-action tw-text-base tw-font-medium tw-px-4">
              <span>{{ "or" | i18n }}</span>
            </div>
            <div
              class="tw-flex-1 tw-border tw-border-color-border-subtle tw-shadow-border-bottom"
            ></div>
          </div>
          <button
            class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-w-full tw-h-12 tw-rounded-full tw-border tw-border-color-border-subtle"
            type="button"
            [disabled]="isLoading"
            (click)="loginWithGoogle()"
            data-testid="loginWithGoogleButton"
          >
            <img src="images/google-logo.svg" alt="" width="18" height="18" />
            <span>{{ "signInWithGoogle" | i18n }}</span>
          </button>
        </div>
      }

      @if (canShowBiometricButton) {
        <div class="tw-flex tw-flex-col tw-gap-2 tw-items-center tw-mt-6">
          <div class="tw-flex tw-items-center tw-w-full">
            <div
              class="tw-flex-1 tw-border tw-border-color-border-subtle tw-shadow-border-bottom"
            ></div>
            <div class="tw-text-color-text-action tw-text-base tw-font-medium tw-px-4">
              <span>{{ "loginWithBiometrics" | i18n }}</span>
            </div>
            <div
              class="tw-flex-1 tw-border tw-border-color-border-subtle tw-shadow-border-bottom"
            ></div>
          </div>
          <div class="tw-flex tw-gap-3">
            <button (click)="loginWithFingerprint()" type="button">
              <icon [name]="biometricIcon" [size]="16"></icon>
            </button>
          </div>
        </div>
      }
    </ng-container>
  </div>

  <div class="tw-m-6 tw-flex tw-items-center tw-justify-center tw-text-sm">
    {{ "doNotHaveAccount" | i18n }}
    <a
      class="tw-cursor-pointer tw-text-dt-text-information tw-underline tw-pl-2 hover:tw-text-dt-text-information"
      (mousedown)="handleCreateAccount()"
      data-testid="createAccountButton"
      >{{ "signUp" | i18n }}
    </a>
  </div>
</form>

<style>
  @keyframes slideInFromTop {
    0% {
      transform: translateY(-100px);
      opacity: 0;
    }

    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

  .slide-in {
    animation: slideInFromTop 1.5s ease-in-out forwards;
  }

  @keyframes slideInFromBottom {
    0% {
      transform: translateY(100px);
      opacity: 0;
    }

    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

  .slide-in-bottom {
    animation: slideInFromBottom 1.5s ease-in-out forwards;
  }
</style>
